import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { YEAR_ADDEDIT, YEAR_WOP_LIST, YEAR_DELETE } from "../../api/constApi";
import { AddEditYearApi, yearWopListApi, yearDeleteApi } from "../Services/yearService";

export const addEditYears = createAsyncThunk(YEAR_ADDEDIT, async (payload) => {
    const response = await AddEditYearApi(payload);
    return response.data;
});

export const yearsWopList = createAsyncThunk(YEAR_WOP_LIST, async (payload) => {
    const response = await yearWopListApi(payload);
    return response.data;
});

export const deleteYear = createAsyncThunk(YEAR_DELETE, async (payload) => {
    const response = await yearDeleteApi(payload);
    return response.data;
});

export const yearSlice = createSlice({
    name: "year",
    initialState: {
        year: null,
        // districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(yearsWopList.fulfilled, (state, action) => {
            state.year = action?.payload;
        });
        builder.addCase(addEditYears.fulfilled, (state, action) => {
            state.year = action?.payload?.Data;
        });
    }
});

export default yearSlice.reducer;